import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\"><rect y=\".5\" width=\"16\" height=\"16\" rx=\"8\" /><path d=\"M11.925 5.087a.383.383 0 0 0-.538 0L6.915 9.514 4.61 7.218a.382.382 0 0 0-.537 0l-.807.799a.375.375 0 0 0 0 .532l3.377 3.364a.385.385 0 0 0 .537 0l5.55-5.494a.374.374 0 0 0 0-.535l-.806-.797Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol